// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraLabelTemplate from '@front/templates/TerceraLabelTemplate.html';
import { Control } from './Control';
import $ from 'jquery';
export class TerceraLabel extends Control {
    constructor() {
        super();
    }
    oncomplete() {
        super.oncomplete();
        this.observe('text', (newValue) => {
            void this.set({ innerHTML: newValue });
        });
    }
    realRelativeBottom() {
        const $root = $(this.find('div'));
        return this.get('top') + $root.height();
    }
}
Control.extendWith(TerceraLabel, {
    template: TerceraLabelTemplate,
    data: function () {
        return {
            text: '',
            innerHTML: '',
            style: '',
            additionalClass: ''
        };
    }
});
